import { useAuth } from '../../providers/auth/useAuth'
import { firstNameFromEmail } from '../../lib/emailName'

function greeting() {
  const hour = new Date().getHours()
  if (hour < 12) return 'Good morning'
  if (hour < 18) return 'Good afternoon'
  return 'Good evening'
}

export default function HomeHero() {
  const { user } = useAuth()
  const firstName = firstNameFromEmail(user?.email)

  return (
    <header className="relative bg-linear-to-b from-purple-50 via-purple-50/60 to-white py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-[radial-gradient(ellipse_70%_80%_at_50%_0%,rgba(126,34,206,0.10)_0%,rgba(255,255,255,0)_70%)]" />

      <div className="mx-auto max-w-3xl px-6 text-center">
        <p className="text-[13px] font-medium tracking-[0.08em] text-purple-700/70 uppercase">
          {greeting()}
          {firstName && (
            <>
              <span className="mx-2 text-purple-300">·</span>
              <span className="text-purple-900">{firstName}</span>
            </>
          )}
        </p>
        <h1 className="mt-2 font-serif text-[44px] leading-[0.98] tracking-[-0.025em] text-slate-900 sm:text-[64px] lg:text-[76px]">
          <span className="font-light">What do you want to</span>
          <span className="font-normal text-purple-700 italic"> build</span>
          <span className="ml-[0.15em] font-light">?</span>
        </h1>
      </div>
    </header>
  )
}
